import React from 'react';
import { useTranslation } from 'react-i18next';

import { JobResourceLinks } from '@/console/features/jobs/components/job-resource-links/job-resource-links';
import { TJobRenderComponentProps } from '@/console/features/jobs/components/jobs-list/jobs-list-renderer.types';
import { DevicesIcon } from '@/shared/assets/icons/devices-icon';
import { useReadDevicesByIdsQuery } from '@/shared/redux/api/assets/devices/devices-api';
import { isPermissionDeniedError } from '@/shared/redux/api/utils/error-handlers';

export const JobDevices: React.FC<TJobRenderComponentProps> = ({
  job,
  truncate,
}) => {
  const { t } = useTranslation();
  const deviceIds = job?.deviceIds;

  const { data, error, isLoading, isFetching } = useReadDevicesByIdsQuery(
    { deviceIds: deviceIds! },
    { skip: !deviceIds?.length },
  );

  const namesById = Object.fromEntries(
    data?.readDevicesByIds?.items?.map((device) => [
      device.deviceId,
      device.name,
    ]) ?? [],
  );

  return (
    <JobResourceLinks
      ids={deviceIds}
      namesById={namesById}
      isPending={isLoading || isFetching}
      isProtected={Boolean(data) || isPermissionDeniedError(error)}
      resourceType="device"
      deletedLabel={t('device:deleted_device')}
      icon={DevicesIcon}
      getPath={(deviceId) => `/devices/${deviceId}`}
      truncate={truncate}
    />
  );
};
